
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {classesApi, materiaApi} from '@/api';
import Empty from '@/components/Empty/index.vue';

@Component({
    components: {
        Empty
    }
})
export default class Class_Authorize extends Vue {
    @Prop({default: ''}) courseId?: any;
    @Prop({default: []}) private classList!: any;
    @Emit('closeModal') private closeModal() {}
    @Emit('refreshClassList') private refreshClassList() {}
    //===================================data区域begin
    schoolId: string = '';
    pager: any = {
        default: {
            pagesize: 15,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    query: any = {
        name: ''
    };
    classLoading: boolean = false;
    // 课程表单表头
    columnsCourse: any = [
        {
            dataIndex: 'name',
            title: '班级名称',
            scopedSlots: {
                customRender: ''
            }
        }
    ];

    // 表格多选框选中的key
    selectedRowKeys: any = [];
    // 选中的班级数据
    selectClassItem: any = [];
    // 表格滚动对象数据
    scroll: any = {
        y: 538
    };
    // 班级列表分页滚动
    scrollTop: any = [];
    allPagenum: number = 0;
    //===================================data区域end

    //===================================computed区域begin
    get rowSelection() {
        return {
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //     //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = selectedRowKeys;
                // console.log(selectedRowKeys);
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                // console.log(record);
                if (selected) {
                    if (!this.selectClassItem.includes(record._id)) {
                        this.selectClassItem.push(record);
                    }
                }
                if (!selected) {
                    for (let i = 0; i < this.selectClassItem.length; i++) {
                        if (record._id == this.selectClassItem[i]._id) {
                            this.selectClassItem.splice(i, 1);
                        }
                    }
                }
                // console.log(this.selectClassItem);
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    selectedRows.forEach((el: any) => {
                        // console.log(el);
                        if (this.selectClassItem.length > 0) {
                            if (!this.selectClassItem.some((e: any) => e._id == el._id || el.hasThisCourse === true)) {
                                this.selectClassItem.push(el);
                            }
                        } else {
                            if (el.hasThisCourse === false) {
                                this.selectClassItem.push(el);
                            }
                        }
                    });
                } else {
                    this.selectClassItem = [];
                }
                // console.log(this.selectClassItem);
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({
                props: {
                    disabled: record.hasThisCourse ? true : false,
                    defaultChecked: record.hasThisCourse ? true : false
                }
            })
        };
    }
    //===================================computed区域end

    //===================================methods区域begin
    getClassList(value: any) {
        this.query.name = value;
        this.pager.default.pagenum = 1;
        this.getList();
    }
    // 处理表格滚动
    scrollOrNot() {
        this.$nextTick(() => {
            // console.log(document.querySelectorAll('.ant-table-body')[1].clientHeight);
            let height = document.querySelectorAll('.ant-table-body')[1]?.clientHeight;
            if (height < 538) {
                this.scroll = {};
            } else {
                this.scroll = {
                    y: 538
                };
            }
        });
    }

    // 右侧取消课程
    onCancel(item: any) {
        // console.log(item);
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
            if (item._id == this.selectedRowKeys[i]) {
                this.selectedRowKeys.splice(i, 1);
            }
        }
        for (let j = 0; j < this.selectClassItem.length; j++) {
            if (this.selectClassItem[j]._id == item._id) {
                this.selectClassItem.splice(j, 1);
            }
        }
        // console.log(this.selectClassItem);
    }
    getList() {
        let me = this;
        me.classLoading = true;
        let urlQueryParmas = {
            schoolId: me.schoolId,
            name: me.query.name,
            page: me.pager.default.pagenum,
            pagesize: me.pager.default.pagesize
        };
        classesApi.getClassPage({
            context: me,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log(data.data.list);
                data.data.list.forEach((item: {_id: any; hasThisCourse: boolean}) => {
                    item.hasThisCourse = false;
                    me.classList.forEach((list: {classId: any}) => {
                        if (item._id == list.classId) {
                            item.hasThisCourse = true;
                        }
                    });
                });
                if (me.pager.default.pagenum > 1) {
                    me.pager.default.rows = me.pager.default.rows.concat(data.data.list);
                } else {
                    me.pager.default.rows = data.data.list;
                }

                me.allPagenum = data.data.pageCount;
                // me.scrollOrNot();
                me.classLoading = false;

                // 滚动加载
                me.scrollTop = document.querySelector('.course-table');
                me.scrollTop.addEventListener('scroll', (e: any) => {
                    let scrollTop = e.target.scrollTop;
                    let clientHeight = e.target.clientHeight;
                    let scrollHeight = e.target.scrollHeight;
                    if (scrollTop + clientHeight === scrollHeight && me.allPagenum !== me.pager.default.pagenum) {
                        me.pager.default.pagenum++;
                        me.getList();
                    }
                });
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
                me.classLoading = false;
            }
        });
    }
    handleCancel() {
        this.$emit('closeModal');
    }
    handleOk() {
        let me = this;
        if (me.selectClassItem.length == 0) {
            me.$message.error('当前未选中班级');
            return;
        }
        let classIdList: any = [];
        for (let i = 0; i < me.selectClassItem.length; i++) {
            classIdList.push(me.selectClassItem[i]._id);
        }
        let formData = {
            classIdList: classIdList,
            courseIdList: [me.courseId],
            schoolId: me.schoolId,
            associatedType: 'byAdmin'
        };
        // console.log(formData);
        materiaApi.saveOutAuthorization({
            context: me,
            data: formData,
            success(data: any, parameters: any) {
                me.$message.success('操作成功!');
                me.handleCancel();
                me.$emit('refreshClassList');
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //===================================methods区域end

    created() {
        let state = this.$app.getState();
        this.schoolId = state.schoolId;
        // console.log(this);
        this.getList();
    }
    beforeDestroy() {
        this.scrollTop.removeEventListener('scroll', () => {
            console.log('移除了滚动加载');
        });
    }
}
